import React, {useState} from 'react';
import { useQuery } from '@apollo/client';

import SaleCard from '../../elements/SaleCard';
import { BoldLinkText, CardContainer, PageTitle } from '../../elements';
import DataState from 'app/src/components/DataState';

import { SALES_WITH_COUNT } from './queries';

const UpcomingSales = ()  => {
  const { loading, error, data, refetch } = useQuery(
    SALES_WITH_COUNT, { variables: { scopes: ['open'] } }
  );

  return (
    <>
      <PageTitle>Upcoming Sales</PageTitle>
      {loading ?
        <DataState.Loading /> : (
        <CardContainer>
          {data?.salesWithCount.entries?.map(sale => (
            <SaleCard sale={sale} key={sale.id} />
          ))}
        </CardContainer>
      )}
    </>
  )
}

export default UpcomingSales;
